module.exports = __webpack_public_path__ + "static/Avenir-Heavy-c8bf2e313d8a72866b1893f678b4c5da.svg";